export default __webpack_public_path__ + "static/media/headphones.b24abd59.jpg";